import { PdpRespTitle_item as Item } from '../PdpRespTitle/__generated__/PdpRespTitle_item.graphql';

export const getByDocCreator = (creators: Item['creators']): string | null => {
    const byOrDocCreators = (creators || []).find(
        creator => creator?.attribution === 'BY' || creator?.attribution === 'BY_AND_DOCUMENTED'
    );
    const byOrDocCreatorInfo = byOrDocCreators?.creator;
    return byOrDocCreatorInfo?.displayName || byOrDocCreatorInfo?.name || null;
};
